export type WorkArea = { width: number; height: number };
export type WindowBounds = { x: number; y: number; width: number; height: number };
export type WindowSnap = "left" | "right";

export function clampWindowBounds(bounds: WindowBounds, area: WorkArea): WindowBounds {
  const width = Math.max(Math.min(420, area.width), Math.min(bounds.width, area.width));
  const height = Math.max(Math.min(280, area.height), Math.min(bounds.height, area.height));
  return {
    width,
    height,
    x: Math.max(0, Math.min(bounds.x, area.width - width)),
    y: Math.max(0, Math.min(bounds.y, area.height - height)),
  };
}

export function initialWindowBounds(area: WorkArea, sequence = 0): WindowBounds {
  const width = Math.min(1040, Math.max(420, area.width - 160));
  const height = Math.min(760, Math.max(280, area.height - 64));
  const cascade = (sequence % 5) * 22;
  return clampWindowBounds({ width, height, x: (area.width - width) / 2 + cascade, y: 24 + cascade }, area);
}

export function snappedWindowBounds(area: WorkArea, side: WindowSnap): WindowBounds {
  const leftWidth = Math.floor(area.width / 2);
  return { x: side === "left" ? 0 : leftWidth, y: 0, width: side === "left" ? leftWidth : area.width - leftWidth, height: area.height };
}

export function moveWindowBounds(bounds: WindowBounds, dx: number, dy: number, area: WorkArea): WindowBounds {
  return clampWindowBounds({ ...bounds, x: bounds.x + dx, y: bounds.y + dy }, area);
}

export function resizeWindowBounds(bounds: WindowBounds, dx: number, dy: number, area: WorkArea): WindowBounds {
  const maximumWidth = area.width - bounds.x;
  const maximumHeight = area.height - bounds.y;
  return {
    ...bounds,
    width: Math.max(Math.min(420, maximumWidth), Math.min(bounds.width + dx, maximumWidth)),
    height: Math.max(Math.min(280, maximumHeight), Math.min(bounds.height + dy, maximumHeight)),
  };
}

export function normalizedAppSearch(value: string) {
  return value.normalize("NFD").replace(/\p{M}/gu, "").trim().toLocaleLowerCase("pt-BR");
}
